import React, { useState, useEffect } from "react";
import {
  message,
  Button,
  Form,
  Space,
  Tooltip,
  Modal,
  Tag,
  Drawer,
  Input,
  DatePicker,
  Row,
  Col,
  TreeSelect,
} from "antd";
import { Link } from "react-router-dom";
import {
  EditOutlined,
  ExclamationCircleFilled,
  EyeOutlined,
} from "@ant-design/icons";
import moment from "moment";

import FormSearch from "./Components/FormSearch";
import ModalForm from "./Components/ModalForm";
import DataTable from "../../Components/Common/DataTable";
import {
  deleteShift,
  getPagingShift,
  insertShift,
  updateShift,
  deleteManyShift,
  getShiftManagementPage,
} from "../../helpers/helper";
import { extractManyId } from "../../common/function";
import { Trans, useTranslation } from "react-i18next";

const { confirm } = Modal;
const Employee = () => {
  const { t } = useTranslation();
  document.title = t("menuManagerAttendance");

  const { RangePicker } = DatePicker;

  const [form] = Form.useForm();
  const [treeDataDepartmentValue, setTreeDataDepartmentValue] = useState([]);
  const [treeDataDepartment, setTreeDataDepartment] = useState([]);

  const [formSearch] = Form.useForm();
  const [listShift, setListShift] = useState([]);
  const [listDepartment, setListDepartment] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [listDateActive, setListDateActive] = useState([]);
  // delete attendance
  const [visibleForm, setVisibleForm] = useState(false);
  //handle date time
  const [dates, setDates] = useState([]);
  const [dateDelete, setDateDelete] = useState([]);
  //pagination
  const [totalPage, setTotalPage] = useState(1);
  const [indexPage, setPageIndex] = useState(1);
  const [loading, setLoading] = useState(true);
  const [loadingModal, setLoadingModal] = useState(false);
  const [pageSize, setPageSize] = useState(10);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loadingDeleteRows, setLoadingDeleteRows] = useState(false);
  const MIN_TIME_ACITVE = 10.0;

  const getAllData = async (_prams) => {
    try {
      const params = _prams
        ? _prams
        : {
            pageIndex: indexPage,
            pageSize: pageSize,
            search: "",
          };
      const dataRes = await getPagingShift(params);
      setTotalPage(dataRes.totalPages);
      if (!dataRes) {
        message.error(t("requiredPermission"));
        return false;
      }
      const data = convertDataTable(dataRes.data);
      return dataRes?.data ? data : false;
    } catch (error) {
      message.error(t("requiredPermission"));
      return [];
    }
  };

  const convertDataTable = (dataRes) => {
    let arrayDateActive = [];
    const data =
      dataRes &&
      dataRes.length > 0 &&
      dataRes.map((item) => {
        let seconds = moment().diff(moment(item.createdTime), "seconds");
        let time_active = item.shiftMinute * 60 || MIN_TIME_ACITVE * 60;

        if (seconds <= time_active) {
          arrayDateActive.push({
            createdTime: item.createdTime,
            key: item._id,
            shiftName: item.shiftName,
            timeLeft: time_active - seconds,
            shiftSecond: time_active,
          });
        }
        return {
          key: item._id,
          shiftName: item.shiftName,
          shiftMinute: item.shiftMinute,
          departments: item.departments,
          companyNames: item.companies
            ? item.companies.map((company) => company.companyName)
            : [],
          companyIds: item.companies
            ? item.companies.map((company) => company._id)
            : [],
          departmentNames: item.departments
            ? item.departments.map((department) => department.departmentName)
            : [],
          departmentIds: item.departments
            ? item.departments.map((department) => department._id)
            : [],
          groupNames: item.groups
            ? item.groups.map((group) => group.groupName)
            : [],
          groupIds: item.groups ? item.groups.map((group) => group._id) : [],
          groups: item.groups || [],
          createdTime: moment(new Date(item.createdTime)).format(
            "DD/MM/YYYY HH:mm"
          ),
          timeDateActive: seconds <= time_active,
          createdById: item.createdBy ? item.createdBy._id : "",
          createdByName: item.createdBy ? item.createdBy.username : "",
        };
      });
    setListDateActive(
      arrayDateActive.sort((a, b) => moment(a.timeLeft) - moment(b.timeLeft))
    );
    return dataRes ? data : [];
  };

  const setlistAllDepartment = async (data) => {
    let listDepartment =
      data &&
      data.length > 0 &&
      data.map((item) => {
        return {
          _id: item._id,
          departmentName: item.departmentName,
        };
      });
    setListDepartment(listDepartment || []);
  };

  const getAllDepartment = (dataRes) => {
    if (!dataRes) {
      return false;
    }
    setlistAllDepartment(dataRes);
    const data =
      dataRes.length > 0 &&
      dataRes.map((company) => {
        return {
          title: company?.companyName,
          value: `company_${company._id}`,
          key: `company_${company._id}`,
          children: company?.departments?.map((department) => {
            return {
              title: department?.departmentName,
              value: `department_${department._id}_company_${company._id}`,
              key: `department_${department._id}_company_${company._id}`,
              children: department?.groups?.map((group) => {
                return {
                  title: group?.groupName,
                  value: `group_${group._id}_department_${department._id}_company_${company._id}`,
                  key: `group_${group._id}_department_${department._id}_company_${company._id}`,
                };
              }),
            };
          }),
        };
      });
    return dataRes ? data : [];
  };

  useEffect(() => {
    setLoading(true);
    async function fetchData() {
      try {
        const data = await getShiftManagementPage();
        setTotalPage(data.dataPage?.totalPages);

        const dataShowTable = convertDataTable(data.dataPage?.data);
        setListShift(dataShowTable);

        setTreeDataDepartment(getAllDepartment(data?.allCompanies) || []);
      } catch (error) {
        console.log(error);
        message.error(t("requiredPermission"));
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    let timer;

    if (listDateActive.length > 0) {
      timer = setTimeout(() => {
        handleRefresh();
      }, listDateActive[0].timeLeft * 1000);
    }
    return () => clearTimeout(timer);
  }, [listDateActive]);

  const handleSearch = async () => {
    const dataForm = formSearch.getFieldsValue();
    if (!Object.values(dataForm).some((item) => !!item) && dates.length === 0) {
      return;
    }
    const params = {
      pageIndex: 1,
      pageSize: pageSize,
      ...getFormSearch(),
    };
    const dataRes = await getAllData(params, 1);
    setListShift(dataRes.length > 0 ? dataRes : false);
    setPageIndex(1);
  };

  const handleRefresh = async () => {
    const _params = {
      pageIndex: 1,
      pageSize: 10,
      search: "",
    };
    const dataRes = await getAllData(_params, indexPage);
    if (dataRes && dataRes.length > 0) {
      setPageIndex(1);
      setListShift(dataRes);
      setDates([]);
    }
    formSearch.resetFields();
  };

  const handleNewShift = async () => {
    setShowModal(true);
    setTitleModal(t("createShiftAttendance"));
  };

  const handleClodeModal = async () => {
    setShowModal(false);
  };

  const handleSubmitForm = async (data) => {
    try {
      setLoadingModal(true);
      if (data.shiftName) {
        data.shiftName = data.shiftName.trim();
      }
      if (data.departments) {
        let companyIds = [];
        let departmentIds = [];
        let groupIds = [];

        data.departments.forEach((department) => {
          const ids = extractManyId(department);
          if (ids.company) {
            companyIds.push(ids.company);
          }
          if (ids.department) {
            departmentIds.push(ids.department);
          }
          if (ids.group) {
            groupIds.push(ids.group);
          }
        });
        data.companies = [...new Set(companyIds)];
        data.departments = [...new Set(departmentIds)];
        data.groups = [...new Set(groupIds)];
      }
      if (!data.id) {
        const dataRes = await insertShift(data);
        if (dataRes.status === 1) {
          message.success(t("saveSuccess"));
        } else if (dataRes.status === 2) {
          message.error(dataRes.message);
        } else {
          if (dataRes.data.code) message.error(t("saveFailByCode"));
          else if (dataRes.data.errors) message.error(t("saveFailByError"));
          else message.error(t("saveFail"));
        }
        handleRefresh();
      } else {
        const shift = listShift.find((shift) => shift.key === data.id);
        const equalArray =
          JSON.stringify(data.companies) === JSON.stringify(shift.companyIds) &&
          JSON.stringify(data.groups) === JSON.stringify(shift.groupIds) &&
          JSON.stringify(data.departments) ===
            JSON.stringify(shift.departmentIds);
        if (
          data.shiftName === shift.shiftName &&
          data.shiftMinute === shift.shiftMinute &&
          equalArray
        ) {
          message.success(t("dataNotChange"));
        } else {
          const dataRes = await updateShift(data.id, data);
          dataRes.status === 1
            ? message.success(t("saveSuccess"))
            : message.error(t("saveFail"));
          handleRefreshData();
        }
      }

      setShowModal(false);
    } catch (e) {
      if (!data.id) message.error(t("permisstionDeniedAction"));
      else message.error(t("permisstionDeniedAction"));
    } finally {
      setLoadingModal(false);
      setShowModal(false);
    }
  };

  const columns = [
    {
      title: t("shiftAttendanceName"),
      dataIndex: "shiftName",
    },
    {
      title: t("company"),
      dataIndex: "companyNames",
      render: (_, record) => {
        return record.companyNames.map((company, index) => (
          <p key={index}>{company}</p>
        ));
      },
    },
    {
      title: t("department"),
      dataIndex: "departmentNames",
      render: (_, record) => {
        return record.departmentNames.map((department, index) => (
          <p key={index}>{department}</p>
        ));
      },
    },
    {
      title: t("group"),
      dataIndex: "groupNames",
      render: (_, record) => {
        return record.groupNames.map((group, index) => (
          <p className="mb-0" key={index}>
            {group}
          </p>
        ));
      },
    },
    {
      title: t("attendanceTime"),
      dataIndex: "shiftMinute",
      render: (_) => {
        return _ ? <span>{_} phút</span> : "";
      },
    },
    {
      title: t("createdBy"),
      dataIndex: "createdByName",
    },
    {
      title: t("createdTime"),
      dataIndex: "createdTime",
    },
    {
      title: t("status"),
      dataIndex: "timeDateActive",
      render: (_) => {
        return _ ? (
          <Tag color="#87d068">{t("active")}</Tag>
        ) : (
          <Tag color="#f50">{t("notActive")}</Tag>
        );
      },
    },
    {
      title: t("action"),
      dataIndex: "",
      render: (_, record) =>
        listShift.length >= 1 ? (
          <Space>
            <Tooltip title={t("description")}>
              <Link to={"/attendance/" + record.key}>
                <Button
                  type="default"
                  shape="circle"
                  icon={<EyeOutlined />}
                  size="small"
                  onClick={() => onEdit(record.key)}
                />
              </Link>
            </Tooltip>
            <Tooltip title={t("edit")}>
              <Button
                type="primary"
                shape="circle"
                icon={<EditOutlined />}
                size="small"
                onClick={() => onEdit(record.key)}
              />
            </Tooltip>
          </Space>
        ) : null,
    },
  ];

  const onEdit = (key) => {
    const dataEdit = listShift.filter((item) => item.key === key);

    const groupIds = dataEdit[0].groups.map(
      (group) =>
        `group_${group._id}_department_${group.department._id}_company_${group.department.company}`
    );
    let departmentIds = [];
    dataEdit[0].departments.forEach((department) => {
      if (department.groups.length === 0) {
        departmentIds.push(
          `department_${department._id}_company_${department.company}`
        );
      }
    });
    setShowModal(true);
    form.setFieldsValue({
      id: dataEdit[0].key,
      shiftName: dataEdit[0].shiftName,
      shiftMinute: `${dataEdit[0].shiftMinute}`,
      departments: groupIds.concat(departmentIds),
    });
    setTitleModal(t("updateShiftAttendance"));
  };

  const showModalConfirmDelete = () => {
    confirm({
      title: t("confirmDelete"),
      icon: <ExclamationCircleFilled />,
      okText: t("delete"),
      okType: "danger",
      cancelText: t("cancel"),
      onOk() {
        onDelete();
      },
      onCancel() {},
    });
  };

  const onPageChange = (page, page_size) => {
    setPageIndex(page);
    setPageSize(page_size);
    onPageChangeAtSearch(page, page_size);
  };

  const onPageChangeAtSearch = async (indexPage, page_size) => {
    setLoading(true);
    const params = {
      pageIndex: indexPage,
      pageSize: page_size,
      ...getFormSearch(),
    };
    const dataRes = await getAllData(params, indexPage);
    setListShift(dataRes.length > 0 ? dataRes : false);
    setLoading(false);
  };

  const onChangeRangePickerDelete = (value) => {
    if (value?.length === 2) {
      setDateDelete(value);
    } else {
      setDateDelete([]);
    }
  };

  const handleShowModalDelete = () => {
    setVisibleForm(true);
  };

  const onClose = () => {
    setVisibleForm(false);
  };

  const onDelete = async () => {
    try {
      if (dateDelete.length === 2) {
        const timeStart =
          moment(dateDelete[0]._d).utc("+0700").format("YYYY-MM-DD HH:mm") ||
          "";
        const timeEnd =
          moment(dateDelete[1]._d).utc("+0700").format("YYYY-MM-DD HH:mm") ||
          "";

        const data = {
          gte: timeStart,
          lte: timeEnd,
        };
        const dataRes = await deleteShift(data);
        message.success(
          <Trans
            i18nKey="deleteShiftAttendanceSuccess"
            values={{ count: dataRes.deletedCount }}
          />
        );
        setDateDelete([]);
        setVisibleForm(false);
        handleRefresh();
      } else {
        message.error(t("deleteFail"));
      }
    } catch (error) {
      setVisibleForm(false);
      message.error(t("permisstionDeniedAction"));
    }
  };

  const onTreeSelectChange = (newValue) => {
    setTreeDataDepartmentValue(newValue);
  };

  const treeDataDepartmentProps = {
    treeData: treeDataDepartment,
    value: treeDataDepartmentValue,
    onChange: onTreeSelectChange,
  };

  const treeDataDepartmentSearchProps = {
    treeData: treeDataDepartment,
  };

  const handleDeleteSelectRows = async () => {
    confirm({
      title: (
        <Trans
          i18nKey="confirmDeleteManyShiftAttendance"
          values={{ count: selectedRowKeys.length }}
        />
      ),
      icon: <ExclamationCircleFilled />,
      okText: t("delete"),
      okType: "danger",
      cancelText: t("cancel"),
      onOk() {
        OnDeleteSelectRows();
      },
      onCancel() {},
    });
  };

  const getFormSearch = () => {
    const dataForm = formSearch.getFieldsValue();
    const ids = extractManyId(dataForm.department);
    return {
      shiftName: dataForm.shiftName || "",
      createdTimeStart:
        (dates.length === 2 &&
          moment(dates[0]?._d).utc("+0700").format("YYYY-MM-DD HH:mm")) ||
        "",
      createdTimeEnd:
        (dates.length === 2 &&
          moment(dates[1]?._d).utc("+0700").format("YYYY-MM-DD HH:mm")) ||
        "",
      company: ids.company || "",
      department: ids.department || "",
      group: ids.group || "",
    };
  };
  const handleRefreshData = async (index_page) => {
    const _params = {
      pageIndex: index_page ? index_page : indexPage,
      pageSize: pageSize,
      ...getFormSearch(),
    };
    const dataRes = await getAllData(_params);
    setListShift(dataRes);
    setPageIndex(index_page ? index_page : indexPage);
  };
  const handleRefreshDataDelete = async (countRemove) => {
    const indexPageNew =
      listShift.length === countRemove
        ? indexPage === 1
          ? 1
          : indexPage - 1
        : indexPage;
    handleRefreshData(indexPageNew);
  };
  const OnDeleteSelectRows = async () => {
    try {
      setLoadingDeleteRows(true);

      const dataRes = await deleteManyShift({ data: { ids: selectedRowKeys } });

      if (dataRes.status === 1) {
        message.success(
          <Trans
            i18nKey="deleteManyShiftAttendanceSuccess"
            values={{ count: dataRes.data.deletedCount }}
          />
        );
        handleRefreshDataDelete(dataRes.data.deletedCount);
      } else {
        message.error(t("permisstionDeniedAction"));
      }

      setSelectedRowKeys([]);
      setLoadingDeleteRows(false);
    } catch (error) {
      setLoadingDeleteRows(false);
      message.error(t("permisstionDeniedAction"));
    }
  };
  return (
    <>
      <div className="page-content text-center">
        <FormSearch
          formSearch={formSearch}
          treeSelectProps={treeDataDepartmentSearchProps}
          handleSearch={handleSearch}
          handleRefresh={handleRefresh}
          handleNewShift={handleNewShift}
          listDepartment={listDepartment}
          handleShowModalDelete={handleShowModalDelete}
          dates={dates}
          setDates={setDates}
          loadingDeleteRows={loadingDeleteRows}
          selectedRowKeys={selectedRowKeys}
          handleDeleteSelectRows={handleDeleteSelectRows}
        />

        <DataTable
          listData={listShift}
          pageSize={pageSize}
          columns={columns}
          indexPage={indexPage}
          totalPage={totalPage}
          onPageChange={onPageChange}
          loading={loading}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
        />

        <Drawer
          title={t("deleteShiftAttendanceTimePeriod")}
          placement={"right"}
          width={"30%"}
          onClose={onClose}
          open={visibleForm}
          bodyStyle={{
            paddingBottom: 80,
          }}
          style={{ marginTop: "70px" }}
        >
          <Form layout="vertical" autoComplete="off">
            <Row>
              <Col sm={4} hidden={true}>
                <Form.Item name="id" label="Id">
                  <Input name="id" />
                </Form.Item>
              </Col>
              <Col className="range-picker">
                <RangePicker
                  showTime={{ format: "HH:mm" }}
                  format="DD-MM-YYYY HH:mm"
                  value={dateDelete}
                  placeholder={[t("startTime"), t("endTime")]}
                  onChange={onChangeRangePickerDelete}
                />
              </Col>
            </Row>
            <Form.Item style={{ paddingTop: "10px" }}>
              <Space>
                <Button
                  type="primary"
                  htmlType="submit"
                  onClick={showModalConfirmDelete}
                >
                  {t("confirm")}
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Drawer>

        <ModalForm
          titleModal={titleModal}
          form={form}
          handleSubmitForm={handleSubmitForm}
          showModal={showModal}
          handleClodeModal={handleClodeModal}
          listDepartment={listDepartment}
          loadingModal={loadingModal}
          treeSelectProps={treeDataDepartmentProps}
        />
      </div>
    </>
  );
};
export default Employee;
